<!--
 * File: catalog-wizard.component.html                                         *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 17th February 2022 11:48:25                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 18th July 2022 15:03:29                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 -->

<p-steps [model]="steps" [readonly]="false"
  [activeIndex]="activeIndex"
  (activeIndexChange)="onActiveIndexChange($event)">
/>

